import React from 'react'
import FormHOC from './FormHOC'
import Button from '../elements/Button'
import InputRow from '../elements/InputRow'
import FancySelectExpiry from '../elements/FancySelectExpiry'

const options = {
    postUrl: '/api/postPaymentMethodCard',
    success: 'Success! Your payment method has been updated successfully.',
    dontScrollToNav: true
}
const state = {}

class PaymentMethodCardForm extends React.Component {
    componentDidUpdate (prevProps) {
        if (prevProps.active !== this.props.active) {
            this.props.setDynamicValues({ active: this.props.active })
        }
    }

    render () {
        return (
            <form onSubmit={this.props.handleSubmit} onKeyDown={this.props.handleKeyDown}>
                <InputRow
                    label='Card number'
                    name='cardNumber'
                    placeholder='Credit/debit card number'
                    type='tel'
                    value={this.props.values.cardNumber}
                    errors={this.props.errors}
                    handleChange={this.props.handleInputChange}
                />
                <InputRow
                    label='Name on card'
                    name='cardName'
                    placeholder='Name on card'
                    value={this.props.values.cardName}
                    errors={this.props.errors}
                    handleChange={this.props.handleInputChange}
                />
                <FancySelectExpiry
                    cardMonth={this.props.values.cardMonth}
                    cardYear={this.props.values.cardYear}
                    errors={this.props.errors}
                    handleChange={this.props.setDynamicValues}
                />
                <InputRow
                    label='CCV code'
                    name='cardCode'
                    placeholder='CCV'
                    type='tel'
                    value={this.props.values.cardCode}
                    errors={this.props.errors}
                    handleChange={this.props.handleInputChange}
                />

                {this.props.children}

                <div className='mt-3 d-flex align-items-center flex-column flex-md-row text-center text-md-left'>
                    <div className='mr-md-4 flex-shrink-0'>
                        <Button title='Update Payment Method' action={this.props.handleSubmit} />
                    </div>
                    <div>
                        <p><small>Payments made by debit or credit card incur up to 1.0% transaction fee, please refer to terms and conditions of your service. You can avoid this fee by electing to pay via Direct Debit. This option is available in your MyExetel portal after order confirmation, under Payment and Invoices.</small></p>
                    </div>
                </div>
            </form>
        )
    }
}

export default FormHOC(PaymentMethodCardForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/PaymentMethodCardForm.js